import {
    Box,
    Button,
    Container,
    Grid,
    Modal,
    Paper, Table, TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import useStyles from "../../styles/styles";
import useTrafficStyles from "../../styles/trafficStyles";

const PromoRefreshConfirmationModal = ({inputs, setInputs, onSave, nextPromoId, incrementPromoIdMutation, closeModal, findAllTrafficSourceListsByTrafficSourceId}) => {
    const classes = useStyles();
    const trafficClasses = useTrafficStyles();

    const [saving, setSaving] = useState(false)
    const findAllTrafficSourceListsByTrafficSourceIdFiltered = findAllTrafficSourceListsByTrafficSourceId.filter(config => !config.includeAndExclude)

    const onConfirm = () => {
        setInputs(inputs => ({
            ...inputs,
            legacyPromoId: nextPromoId
        }));

        setSaving(true)
    }

    useEffect(() => {
        if(inputs && saving){
            console.log("Inputs,", inputs)
            incrementPromoIdMutation()
            onSave()
            setSaving(false)
            closeModal()
        }
    }, [inputs])

    const getConfigTable = () => {
        return <Paper className={classes.paper}>
            <Box style={{maxHeight: "50vh", overflow: "scroll", overflowY: "scroll"}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                #
                            </TableCell>
                            <TableCell>
                                Config Key
                            </TableCell>
                            <TableCell>
                                Category
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {findAllTrafficSourceListsByTrafficSourceIdFiltered.map((config, idx) => (
                            <TableRow>
                                <TableCell>
                                    {idx+1}
                                </TableCell>
                                <TableCell>
                                    {config.key}
                                </TableCell>
                                <TableCell>
                                    {config.category}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Paper>
    }

    return <Modal
        open={true}
        onClose={closeModal}
    >
        <Container className={`${classes.modal} ${trafficClasses.smallModal} `} maxWidth={false}>
            <Paper className={classes.paper} style={{marginBottom: 0}}>
                <Typography variant="h5" align="center" gutterBottom>
                    Are you sure you want to promo refresh this traffic source?
                </Typography>
                <Typography variant="subtitle1" align="center" gutterBottom>
                    This will assign the next available promo Id '{nextPromoId}'
                    to this traffic source.
                </Typography>

                {findAllTrafficSourceListsByTrafficSourceIdFiltered && findAllTrafficSourceListsByTrafficSourceIdFiltered.length > 0 ?
                    <>
                        <Typography variant="subtitle2" align="center" gutterBottom>
                            There are {findAllTrafficSourceListsByTrafficSourceIdFiltered.length} configs that will be refreshed
                        </Typography>
                        {getConfigTable()}
                    </>: null
                }

                <Grid item xs className={trafficClasses.headerButtons}>
                    <Button variant="contained" color="primary" onClick={(e) => {
                        e.preventDefault();
                        onConfirm()
                    }}>
                        Confirm
                    </Button>
                    <Button variant="outlined" onClick={() => closeModal()}>
                        Cancel
                    </Button>
                </Grid>
            </Paper>
        </Container>
    </Modal>
}

export default PromoRefreshConfirmationModal